import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, getCurrentUser } from '../../utils/auth';

/**
 * ProtectedRoute component to handle authentication and route protection
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render if authenticated
 * @param {boolean} props.requireAuth - Whether authentication is required for this route
 * @param {Array} props.allowedRoles - Array of role IDs that can access this route
 * @returns {React.ReactNode} - The protected component or redirect
 */
const ProtectedRoute = ({ children, requireAuth = true, allowedRoles = null }) => {
  const location = useLocation();
  const userIsAuthenticated = isAuthenticated();
  const currentUser = getCurrentUser();

  // If on login page and already authenticated, redirect based on role
  if (location.pathname === '/' && userIsAuthenticated) {
    if (currentUser?.ID_Role === 1) {
      // Admin goes to users management
      return <Navigate to="/utilisateurs" replace />;
    } else if (currentUser?.ID_Role === 2) {
      // User goes to reservation
      return <Navigate to="/reservation" replace />;
    }
    return <Navigate to="/reservation" replace />;
  }

  // If authentication is required but not authenticated, redirect to login
  if (requireAuth && !userIsAuthenticated) {
    return <Navigate to="/" replace />;
  }

  // Check role-based access if allowedRoles is specified
  if (allowedRoles && userIsAuthenticated && currentUser) {
    if (!allowedRoles.includes(parseInt(currentUser.ID_Role))) {
      // Redirect to appropriate page based on user role
      if ( parseInt(parseInt(currentUser.ID_Role)) === 1) {
        return <Navigate to="/utilisateurs" replace />;
      } else if (parseInt(currentUser.ID_Role) === 2) {
        return <Navigate to="/reservation" replace />;
      }
      return <Navigate to="/" replace />;
    }
  }

  // Render children if all conditions are met
  return children;
};

export default ProtectedRoute;